import fs from 'node:fs';
import path from 'node:path';

import chalk from 'chalk';
import inquirer from 'inquirer';

import {downloadTemplate} from './fetch';

export const chooseAndDownloadTemplate = async (
  templates: Template[]
): Promise<string | undefined> => {
  if (templates.length === 0) {
    process.stderr.write(chalk.red('No templates available\n'));

    return;
  }

  const {template} = await inquirer.prompt<{template: string}>([
    {
      choices: templates.map((t) => t.name),
      message: 'Select a template:',
      name: 'template',
      type: 'list'
    }
  ]);

  const selected = templates.find((t) => t.name === template);

  if (!selected) {
    process.stderr.write(chalk.red('Template not found!\n'));

    return;
  }

  const targetPath = path.join(process.cwd(), selected.name);

  if (!fs.existsSync(targetPath)) fs.mkdirSync(targetPath);

  try {
    await downloadTemplate(targetPath, selected.repo);

    return targetPath;
  } catch (err) {
    process.stderr.write(
      chalk.red(`Failed to download template: ${err instanceof Error ? err.message : err}\n`)
    );

    return undefined;
  }
};

export interface Template {
  name: string;
  repo: string;
}
